import { useState } from 'react';
import { TrackedFavouriteLocker } from '../data/Tracking';
import type { ReactSetState } from '../utils/types';
import { v4 as uuidv4 } from "uuid";
import { ContextProviderProps, createContext } from '../common/contextFactory';

type TrackingProps = {
    domain: string;
    setDomain: ReactSetState<string>;
    isSelectLockerClicked: boolean;
    setIsSelectLockerClicked: ReactSetState<boolean>;
    favouriteLockerActioned: TrackedFavouriteLocker;
    setFavouriteLockerActioned: ReactSetState<TrackedFavouriteLocker>;
    correlationId: string;
    setCorrelationId: ReactSetState<string>;
    userFingerprint?: string;
    setUserFingerprint: ReactSetState<string | undefined>;
}

const [useTrackingContext, Provider] = createContext<TrackingProps>('TrackingCtx');

const useInitTrackingContext = () => {
    const [domain, setDomain] = useState<string>("");
    const [isSelectLockerClicked, setIsSelectLockerClicked] = useState<boolean>(false);
    const [favouriteLockerActioned, setFavouriteLockerActioned] = useState<TrackedFavouriteLocker>({} as TrackedFavouriteLocker);
    const [correlationId, setCorrelationId] = useState<string>(uuidv4())
    const [userFingerprint, setUserFingerprint] = useState<string | undefined>(undefined);
    const trackingProps: TrackingProps = {
        domain,
        setDomain,
        isSelectLockerClicked,
        setIsSelectLockerClicked,
        favouriteLockerActioned,
        setFavouriteLockerActioned,
        correlationId,
        setCorrelationId,
        userFingerprint,
        setUserFingerprint
    };
    return trackingProps;
};

const TrackingContextProvider = ({ children }: ContextProviderProps) => {
    return <Provider value={useInitTrackingContext()}>
        {children}
    </Provider>;
};

export { useTrackingContext, TrackingContextProvider };
